import { get } from 'lodash';
import { push } from 'connected-react-router';
import { PAGE_NAME } from '../../../config/pageNames';
import { FLOW_TYPE } from '../../../../framework/App/AppConstants';
import { setServerData } from '../../../../framework/store/ServerData/ServerDataActions';
import setUrl from '../../../../framework/App/SetUrl';

export const sessionTimeoutHandler = (error, dispatch, flow) => {
    const errorData = get(error, 'response.data', {});
    if (errorData?.statusCode === 401 && (flow === FLOW_TYPE.APP_PEND || flow === FLOW_TYPE.DIRECT_APP)) {
        return setUrl(window, '/ppcreditapply/ap/us');
    } else {
        dispatch(setServerData({ errorModel: errorData }));
        dispatch(push(PAGE_NAME.ERROR_PAGE));
    }
};